import InfoBlock from "../../common/components/InfoBlock/InfoBlock";
import { formatDateDDMMYYYY } from "../../common/utils/dateUtils";
import { StatusIcon } from "./StatusIcon";
import { ChangeRequestResourceName } from "./ChangeRequestResourceName";
import {
	ChangeRequestStatus,
	ChangeRequestType,
} from "../../requests_cm/gepoChangeRequestService/types";

export const ChangeRequestInfoBlock = ({
	changeRequest,
}: {
	changeRequest?: ChangeRequestType;
}) => (
	<InfoBlock
		withBackground
		fullWidth
		head={[
			{
				label: changeRequest?.resource_type,
				value: (
					<ChangeRequestResourceName changeRequest={changeRequest} />
				),
			},
		]}
		info={[
			{
				label: "Requester",
				value: (
					<p style={{ textTransform: "capitalize" }}>
						{changeRequest?.requester?.first_name}{" "}
						{changeRequest?.requester?.last_name}
					</p>
				),
			},
			{
				label: "Validator",
				value: (
					<p style={{ textTransform: "capitalize" }}>
						{changeRequest?.validator?.first_name}{" "}
						{changeRequest?.validator?.last_name}
					</p>
				),
			},
			{
				label: "Request date",
				value: formatDateDDMMYYYY(changeRequest?.created_at),
			},
			{
				label: "Status",
				value: (
					<StatusIcon
						status={
							changeRequest?.status ||
							ChangeRequestStatus.PENDING
						}
					/>
				),
			},
		]}
	/>
);
